import { render, staticRenderFns } from "./querenxinxi.vue?vue&type=template&id=58d72036&scoped=true"
import script from "./querenxinxi.vue?vue&type=script&lang=js"
export * from "./querenxinxi.vue?vue&type=script&lang=js"
import style0 from "./querenxinxi.vue?vue&type=style&index=0&id=58d72036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d72036",
  null
  
)

export default component.exports